import { createAxiosInstance } from '../utils/axios.js'

const api = createAxiosInstance()

export const contactService = {
  async submitContactForm (formData) {
    try {
      const payload = {
        name: formData.name,
        email: formData.email,
        subject: formData.subject,
        entry: formData.message
      }
      const response = await api.post('/api/contact', payload)
      return { success: true, data: response.data }
    } catch (error) {
      return {
        success: false,
        error:
          error.response?.data?.error ||
          error.message ||
          'Failed to submit contact form'
      }
    }
  },

  async getContactInfo () {
    try {
      const response = await api.get('/api/contact/info')
      return { success: true, data: response.data }
    } catch (error) {
      return {
        success: false,
        error:
          error.response?.data?.error ||
          error.message ||
          'Failed to fetch contact information'
      }
    }
  }
}
